import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import {
  InventoryPage,
  areInventorySearchEqual,
  inventoryLoaderDeps,
  inventorySearchSchema,
  merchantProductsQueryOptions,
  normalizeInventorySearch,
} from '@/features/inventory';
import { useAuthStore } from '@/stores/auth';

export const Route = createFileRoute('/_authed/inventory/')({
  validateSearch: zodValidator(inventorySearchSchema),
  loaderDeps: ({ search }) => inventoryLoaderDeps(search),
  loader: ({ cause, context, deps }) => {
    if (cause !== 'enter') return;

    const activeBranchId = useAuthStore.getState().activeBranchId;
    const branchId = activeBranchId && activeBranchId !== 'all' ? activeBranchId : undefined;

    void context.queryClient.prefetchQuery(
      merchantProductsQueryOptions({
        ...deps,
        branch_id: branchId,
      }),
    );
  },
  beforeLoad: ({ search }) => {
    const normalizedSearch = normalizeInventorySearch(search);

    if (!areInventorySearchEqual(search, normalizedSearch)) {
      throw redirect({
        to: '/inventory',
        search: normalizedSearch,
        replace: true,
      });
    }
  },
  component: () => <InventoryPage />,
});
